<script setup lang="ts">
import { computed } from 'vue'

import CheckIcon from '@/assets/icons/check.svg?component'
import ChevronIcon from '@/assets/icons/chevron.svg?component'
import type { FilterValueType, ListItemsType } from '@/lib/types/common.types'
import { BoxComponent, FlexComponent, TypographyComponent } from '@/ui-library'

const props = defineProps<{
  options: ListItemsType
  shouldTruncateText?: boolean
}>()
const emits = defineEmits(['update:status'])
const status = defineModel<FilterValueType>('status')
const label = computed(() => props.options.find((item) => item.value === status.value)?.label || 'Status')

const handleAdvertiserGroups = (item: { label: string; value: string }) =>
  emits('update:status', item.value === status.value ? undefined : item.value)
</script>
<template>
  <el-dropdown trigger="click">
    <BoxComponent :p="10">
      <FlexComponent :gap="4" align="center">
        <TypographyComponent variant="label-large">
          {{ label }}
        </TypographyComponent>
        <el-icon :size="18" class="chevron-icon">
          <ChevronIcon />
        </el-icon>
      </FlexComponent>
    </BoxComponent>
    <template #dropdown>
      <BoxComponent :pt="8" :pb="8">
        <el-dropdown-menu v-if="options.length > 0">
          <el-dropdown-item v-for="item in options" :key="item.value" @click="handleAdvertiserGroups(item)">
            <FlexComponent flex="1" justify="space-between">
              <TypographyComponent :variant="item.value === status ? 'title-large' : 'body-large'">
                {{ item.label }}
              </TypographyComponent>
              <el-icon v-if="item.value === status" :size="24">
                <CheckIcon />
              </el-icon>
            </FlexComponent>
          </el-dropdown-item>
        </el-dropdown-menu>
      </BoxComponent>
    </template>
  </el-dropdown>
</template>
<style lang="scss" scoped>
:deep(.el-dropdown-menu) {
  max-height: 440px;
  max-width: 300px;
  overflow: auto;
}
:deep(.el-dropdown-menu__item) {
  padding: 16px;
}
:deep(.el-input--small .el-input__wrapper) {
  padding: 8px;
}
</style>
